import React, { createContext, useState, useContext } from 'react';

const SessionContext = createContext();

/**
 * Sessions keyed by profileId, not a single global session -- lets two (or
 * more) Heroes under one account each have their own independent, live
 * Mission at the same time. RoutinePicker.jsx mounts one ActiveMission per
 * key here (hidden via CSS unless that profile is the currently-focused
 * one, same "stay mounted, hide via display:none" pattern the tab bar
 * already uses), so each profile's in-progress/unlogged state survives
 * switching focus away and back without being lifted into this context.
 */
export const SessionProvider = ({ children }) => {
  const [sessionsByProfile, setSessionsByProfile] = useState({});

  const startSession = (profileId, sessionData) => {
    setSessionsByProfile((prev) => ({ ...prev, [profileId]: sessionData }));
  };

  const endSession = (profileId) => {
    setSessionsByProfile((prev) => {
      const next = { ...prev };
      delete next[profileId];
      return next;
    });
  };

  const getSession = (profileId) => sessionsByProfile[profileId] || null;

  return (
    <SessionContext.Provider value={{ sessionsByProfile, startSession, endSession, getSession }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
